/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Tooltip_Autosync_OnInputs */

const es_settings_dirs_tooltip_autosync_on = /** @type {(inputs: Settings_Dirs_Tooltip_Autosync_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización automática activada`)
};

const en_settings_dirs_tooltip_autosync_on = /** @type {(inputs: Settings_Dirs_Tooltip_Autosync_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-sync enabled`)
};

/**
* | output |
* | --- |
* | "Auto-sync enabled" |
*
* @param {Settings_Dirs_Tooltip_Autosync_OnInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_tooltip_autosync_on = /** @type {((inputs?: Settings_Dirs_Tooltip_Autosync_OnInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Tooltip_Autosync_OnInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_tooltip_autosync_on(inputs)
	return en_settings_dirs_tooltip_autosync_on(inputs)
});
export { settings_dirs_tooltip_autosync_on as "settings.dirs.tooltip.autosync_on" }